import {useEffect} from "react";

export default function KeyMapping({setAddModal}){

  const handleKeyDown = (event) => {
    if(event.key === 'Escape'){
      setAddModal(-1)
    }
  }

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return(<div/>)
}